export const promoTypeOptions = [
    {label: "CASH", value: "CASH"},
    {label: "CREDIT", value: "CREDIT"},
]